module.exports = __webpack_public_path__ + "img/woods_04.8cc3916e.jpg";